/**
 * Supply-temperature classes for the buildings layer.
 *
 * A second reading of the same stock: the A–G letter says how much energy a
 * building wastes, this says what temperature its heating needs — which is what
 * decides whether a district network can serve it at all. A building can be
 * rated C and still need 70 °C radiators, and only this view shows it.
 */

export const TEMP_CLASSES = ["high", "mid", "low", "ambient"] as const;

export type TempClass = (typeof TEMP_CLASSES)[number];

export const TEMP_COLORS: Record<TempClass, string> = {
  high: "#D8613C", // ≥ 65 °C
  mid: "#E8943A", // 50–64 °C
  low: "#B1C5A4", // 40–49 °C
  ambient: "#5EA69B", // < 40 °C
};

/** What each class means for the network that would have to serve it. */
export const TEMP_LABELS: Record<TempClass, string> = {
  high: "≥ 65 °C — sólo 3G",
  mid: "50–64 °C — 4G HT",
  low: "40–49 °C — 4G LT",
  ambient: "< 40 °C — 5G ready",
};

/** Grey for a building the pipeline could not classify. */
export const TEMP_NONE = "#9e9e9e";
